import {TICK_DOMAIN_MY} from '../config/config';
import {logout} from '../redux/user/userActions';
import {dispatchEvent} from '../hooks/dispatchEvent';

// Lives outside RouteComponent so that main-bundle modules (axios interceptors,
// useSocket) can trigger iframe messages/logout without importing the whole
// admin page tree that RouteComponent pulls in via menu.js.
let globalIframeRef = null;

export const setGlobalIframeRef = (ref) => {
    globalIframeRef = ref;
};

export const iframeClick = (buttonClick, type, props = {}) => {
    const iFrame = globalIframeRef?.current?.contentWindow;
    if(iFrame){
        iFrame.postMessage({buttonClick: buttonClick, type: type, props}, TICK_DOMAIN_MY);
    }
    if(buttonClick==='logout'){
        logout().then(()=>{
            dispatchEvent('401Exception');
        }).catch(()=>{
            dispatchEvent('401Exception');
        });
    }
};
